/* eslint-disable import/exports-last */
import SHA from 'sha.js';

import { GA4UserParam } from '../models/configuration.model';
import { GA4UserGroup, GA4UserValues, UserClientTypeString, UserTypeString } from '../models/user.model';
import * as GA4DataUtils from '../utils/ga4-data.utils';

export const defaultConfig: GA4UserGroup = {
    im_user_status: undefined,
    im_user_type: undefined,
    im_user_email_sha256_1: undefined,
    im_user_email_sha256_2: undefined,
    im_user_client_type: undefined,
    im_user_id: undefined,
    im_store_id: undefined,
    im_user_client_id: undefined,
};

export const getUserType = (userType: string): UserTypeString => {
    return userType === 'R' ? UserTypeString.registrado : undefined;
};

export const getUserEmailSha256 = (email: string): string | undefined => {
    if (email) {
        return SHA('sha256').update(email).digest('hex');
    }
    return undefined;
};

export const getUserClientType = (isCompany: boolean): UserClientTypeString => {
    return isCompany ? UserClientTypeString.empresa : UserClientTypeString.particular;
};

export const getUserId = (userId: number): string | undefined => {
    if (userId > 0) {
        return userId.toString();
    }
    return undefined;
};

export const isWW = (): boolean => {
    const location = (window as any).location.href;

    return location.includes('?select-store=true')
        || location === 'https://www.massimodutti.com'
        || location === 'https://www.massimodutti.com/'
        || location === 'https://preint-massimodutticom.inditex.com'
        || location === 'https://preint-massimodutticom.inditex.com/'
        || location === 'https://axinstgeccwps1-massimodutti.central.inditex.grp'
        || location === 'https://axinstgeccwps1-massimodutti.central.inditex.grp/'
        || location === 'https://localhost:6001'
        || location === 'https://localhost:6001/';
};

export const getStoreId = (countryCode: string): string => {
    if (isWW()) {
        return 'DUTTI_ZZ';
    }
    return `DUTTI_${countryCode}`;
};

export const getUserClientId = (gaCookie: string): string => {
    // biome-ignore lint/nursery/useTopLevelRegex: <explanation>
    return gaCookie?.replace(/(GA)(\d+\.){2}/, '');
};

export const getParamValue = (param: GA4UserParam, values: GA4UserValues): string | undefined => {
    switch (param) {
        case GA4UserParam.im_user_status:
            return values.user?.isLogged ? GA4DataUtils.getBooleanSiNo(values.user?.isBuyer) : undefined;

        case GA4UserParam.im_user_type:
            return getUserType(values.user?.userType);

        case GA4UserParam.im_user_email_sha256_1:
            return getUserEmailSha256(values.user?.email ?? (window as any)?.imAnalytics?.email)?.slice(0, 36);

        case GA4UserParam.im_user_email_sha256_2:
            return getUserEmailSha256(values.user?.email ?? (window as any)?.imAnalytics?.email)?.slice(36);

        case GA4UserParam.im_user_client_type:
            return values.user?.isLogged ? getUserClientType(values.user?.isCompany) : undefined;

        case GA4UserParam.im_user_id:
            return getUserId(values.user?.identity?.userId);

        case GA4UserParam.im_store_id:
            return getStoreId(values.store.countryCode);

        case GA4UserParam.im_user_client_id:
            return getUserClientId(values.gaCookie);

        default:
            return undefined;
    }
};

const getParams = (config: GA4UserParam[], values: GA4UserValues): Record<GA4UserParam, string> => {
    const paramValue: Record<GA4UserParam, string> = { ...defaultConfig };
    for (const param of config) {
        paramValue[param] = getParamValue(param, values);
    }

    return paramValue;
};

export const ga4UserProcessConfig = (config: GA4UserParam[], values: GA4UserValues): GA4UserGroup | undefined => {
    if (config?.length) {
        return getParams(config, values);
    }
    return undefined;
};
